import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ONBOARDING_EXPERIENCES } from '../../constants/onboarding-state/onboarding-constants.ts';
import { EDITOR_ONBOARDING_STATE_KEYS } from '../../constants/onboarding-state/onboarding-editor-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';

export const preloadNthUserGettingStartedOnboardingState = () => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [
				// Shared between flag and banner
				ONBOARDING_EXPERIENCES.IMPROVED_GET_STARTED_NTH_USER_PATH,

				// Flag only - likely doesn't show on server side rendering but preloading for consistency
				ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_FLAG_VIEWED,
				ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP,
				ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_PAGE_VIEWED,

				// Banner only
				ONBOARDING_EXPERIENCES.NTH_USER_BANNER_DISMISSED,
				EDITOR_ONBOARDING_STATE_KEYS.HAS_USER_PUBLISHED,
			],
		},
	});
};
